var _rect, _rect2, _circle, _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Custome_Signature",
    "data-name": "Custome Signature",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1230",
    "data-name": "Rectangle 1230",
    width: 30,
    height: 30,
    transform: "translate(1.04 1.02)",
    fill: "#fff",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    width: 32,
    height: 32,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(20.66 11.41)",
    fill: "#f2d388"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    d: "M29.21,27.25H13.39a1.6,1.6,0,0,0,0,3.2H29.21a1.6,1.6,0,0,0,0-3.2Z",
    fill: "#165cf3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3309",
    "data-name": "Group 3309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M22.83,10.49,25.4,7.93,23.75,6.28h.02l-5.06,5.07",
    fill: "none",
    stroke: "#f2d388",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M18.71,11.35,3.49,26.59l-1.68,3.3L5.09,28.2,19.87,13.45",
    fill: "none",
    stroke: "#f2d388",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M27.18,2.38l-2.08,2,2.08,2,2.08-2a1.383,1.383,0,0,0,0-2h0A1.517,1.517,0,0,0,27.18,2.38Z",
    fill: "none",
    stroke: "#f2d388",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureIcon);
export default __webpack_public_path__ + "static/media/signature-icon.dd011cb2a9cdd158c959edc857aeb310.svg";
export { ForwardRef as ReactComponent };